var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-button", {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      loading: _vm.loading,
      disabled: _vm.loading
    },
    on: {
      click: _vm.next
    }
  }, [_vm._v("下一个")]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };